module.exports = __webpack_public_path__ + "static/media/charity-dental-kit.7a3ace57.svg";